import { render, staticRenderFns } from "./ManagePlan.vue?vue&type=template&id=4a90f97c&scoped=true"
import script from "./ManagePlan.vue?vue&type=script&lang=js"
export * from "./ManagePlan.vue?vue&type=script&lang=js"
import style0 from "./ManagePlan.vue?vue&type=style&index=0&id=4a90f97c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90f97c",
  null
  
)

export default component.exports